export class SignatureFound {
  constructor(type, data) {
    this.type = type;
    this.data = data;
  }
}
